module.exports = __webpack_public_path__ + "static/media/5j_website_logo_diamond_towngas.4a0d2278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5j_website_logo_diamond_towngas.jpg
// module id = 94
// module chunks = 0